// src/data/homeSlides.js
export const productsHero = [
  // {
  //   id: 1,
  //   name: "Black Week",
  //   pack: "450 g",
  //   price: 18900,
  //   imageHeroHomeDesktop: "https://anceouck.sirv.com/GymApp/Products/HeroBlackFridayv2.jpg",
  //   imageHeroHomeMobile: "https://anceouck.sirv.com/GymApp/Products/heroblackfridaymobilev1.jpg",
  //   link: "/search",
  //   subtitle: "20% OFF aplicando el PromoCode: BLACK",
  //   textColor: "#f4d27a", // <— color dinámico,
  //   buttonText: "Agregar Productos"    
  // },
  {
    id: 2,
    name: "Brillo y Belleza (3 Pack)",
    pack: "450 g",
    price: 18900,
    imageHeroHomeDesktop: "https://anceouck.sirv.com/GymApp/Products/Glow%26beautydesktop.jpg",
    imageHeroHomeMobile: "https://anceouck.sirv.com/GymApp/Products/glowandbeauty.png",
    link: "/product/23",
    subtitle: "10% descuento si compras este pack",
    textColor: "#f4d27a", // <— color dinámico,
    buttonText: "Comprar Ahora"   
  },
  
  {
    id: 3,
    name: "Balance y Bienestar (3 Pack)",
    pack: "450 g",
    price: 18900,
    imageHeroHomeDesktop: "https://anceouck.sirv.com/GymApp/Products/Herorest%26recoverydesktopV5.jpg",
    imageHeroHomeMobile: "https://anceouck.sirv.com/GymApp/Products/rest%26recoverypackmobilev2.png",
    link: "/product/13",
    subtitle: "10% descuento si compras este pack",
    textColor: "#f4d27a", // <— color dinámico,
    buttonText: "Comprar Ahora"
  },
  {
    id: 4,
    name: "Descansa y Recupera (3 Pack)",
    imageHeroHomeDesktop: "https://anceouck.sirv.com/GymApp/Products/Wellness%26Balancedesktop.jpg",
    imageHeroHomeMobile: "https://anceouck.sirv.com/GymApp/Products/wellness%26balancemovil.png",
    link: "/product/16",
    subtitle: "10% descuento si compras este pack",
    textColor: "#f4d27a", // <— color dinámico,
    buttonText: "Comprar Ahora"
  },
  

  // podés agregar más slides aquí...
];
